export const environment = {
  firebase: {
    projectId: 'resume-cdf24',
    appId: '1:972438190848:web:db3a526b97415a9e1d91e5',
    storageBucket: 'resume-cdf24.appspot.com',
    apiKey: 'AIzaSyBhm8OV2P_wtSrLRkqXDFZHARalKjqeVcA',
    authDomain: 'resume-cdf24.firebaseapp.com',
    messagingSenderId: '972438190848',
    measurementId: 'G-ELTLGLBHEF',
  },
  production: true
};
